


































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BaseCheckbox extends Vue {
  @Prop({ type: String, required: true }) private id!: string;
  @Prop({ type: Boolean, required: true }) private value!: boolean;
  /* tslint:disable-next-line */
  @Prop({ type: Object, required: false, default: () => { } }) private validation!: object;
  @Prop({ type: Boolean, required: false, default: false }) private disabled!: boolean;
}
